import { Component } from '@angular/core';
import { EndUserAgreementContentComponent as BaseComponent } from '../../../../../../app/info/end-user-agreement/end-user-agreement-content/end-user-agreement-content.component';

@Component({
  selector: 'ds-end-user-agreement-contentt',
  templateUrl: './end-user-agreement-content.component.html',
  styleUrls: ['./end-user-agreement-content.component.scss']
})
/**
 * Component displaying the contents of the End User Agreement
 */
export class EndUserAgreementContentComponent extends BaseComponent {
}
